/* RATELIMITED — storefront behaviour. Vanilla, no dependencies. */
(function () {
  "use strict";

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function money(cents) {
    var fmt = window.RL && window.RL.moneyFormat ? window.RL.moneyFormat : "${{amount}}";
    var amount = (cents / 100).toFixed(2);
    var withComma = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var noDecimal = Math.round(cents / 100).toString();
    return fmt
      .replace("{{amount}}", withComma)
      .replace("{{amount_with_comma_separator}}", withComma.replace(/,/g, ".").replace(/\.(\d\d)$/, ",$1"))
      .replace("{{amount_no_decimals}}", noDecimal)
      .replace("{{amount_no_decimals_with_comma_separator}}", noDecimal)
      .replace(/\{\{\s*[\w_]+\s*\}\}/g, amount);
  }

  /* ---------------------------------------------------------------- Reveal */

  function initReveal() {
    var items = $$(".reveal");
    if (!items.length) return;
    if (reduced || !("IntersectionObserver" in window)) {
      items.forEach(function (el) {
        el.classList.add("is-in");
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.05 }
    );
    items.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ------------------------------------------------------- Quota scroll bar */

  function initQuota() {
    var header = $(".header");
    if (!header) return;
    var ticking = false;
    function update() {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var ratio = max > 0 ? Math.min(1, window.scrollY / max) : 0;
      header.style.setProperty("--quota", ratio.toFixed(4));
      ticking = false;
    }
    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    window.addEventListener("resize", update, { passive: true });
    update();
  }

  /* ------------------------------------------------------------ Announce */

  function initAnnounce() {
    var track = $(".announce__track");
    if (!track) return;
    var items = $$(".announce__item", track);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove("is-active");
      i = (i + 1) % items.length;
      items[i].classList.add("is-active");
    }, 5200);
  }

  /* ------------------------------------------------------- Panels / drawers */

  var openPanel = null;

  function setPanel(el, open) {
    var overlay = $("[data-overlay]");
    if (open) {
      if (openPanel && openPanel !== el) setPanel(openPanel, false);
      el.classList.add("is-open");
      el.removeAttribute("aria-hidden");
      if (overlay) overlay.classList.add("is-open");
      document.body.style.overflow = "hidden";
      openPanel = el;
      var focusable = el.querySelector("input, button, a[href]");
      if (focusable) setTimeout(function () { focusable.focus(); }, 60);
    } else {
      el.classList.remove("is-open");
      el.setAttribute("aria-hidden", "true");
      if (overlay) overlay.classList.remove("is-open");
      document.body.style.overflow = "";
      if (openPanel === el) openPanel = null;
    }
  }

  function initPanels() {
    document.addEventListener("click", function (e) {
      var opener = e.target.closest("[data-open]");
      if (opener) {
        var target = $(opener.getAttribute("data-open"));
        if (target) {
          e.preventDefault();
          setPanel(target, !target.classList.contains("is-open"));
        }
        return;
      }
      var closer = e.target.closest("[data-close]");
      if (closer) {
        e.preventDefault();
        var panel = closer.closest(".cart-drawer, .menu-drawer, .search-panel");
        if (panel) setPanel(panel, false);
        return;
      }
      if (e.target.hasAttribute && e.target.hasAttribute("data-overlay")) {
        if (openPanel) setPanel(openPanel, false);
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && openPanel) setPanel(openPanel, false);
    });
  }

  /* ------------------------------------------------------------------ Cart */

  function refreshCartUI(sectionsHtml) {
    if (sectionsHtml && sectionsHtml["cart-drawer"]) {
      var drawer = $("#cart-drawer");
      if (drawer) {
        var parsed = new DOMParser().parseFromString(sectionsHtml["cart-drawer"], "text/html");
        var next = parsed.querySelector("#cart-drawer");
        if (next) {
          drawer.innerHTML = next.innerHTML;
        }
      }
    }
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart.js" : "/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent("rl:cart", { detail: cart }));
      })
      .catch(function () {});
  }

  function initCart() {
    /* Add to cart */
    document.addEventListener("submit", function (e) {
      var form = e.target.closest('form[data-add-to-cart]');
      if (!form) return;
      var drawerEnabled = document.body.hasAttribute("data-cart-drawer");
      if (!drawerEnabled) return;

      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : "";
      if (btn) {
        btn.setAttribute("aria-disabled", "true");
        btn.textContent = "Adding";
      }

      var data = new FormData(form);
      data.append("sections", "cart-drawer");

      fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: data
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) {
            var err = form.querySelector("[data-form-error]");
            if (err) {
              err.textContent = res.body.description || res.body.message || "This item could not be added.";
              err.hidden = false;
            }
            return;
          }
          refreshCartUI(res.body.sections);
          var drawer = $("#cart-drawer");
          if (drawer) setPanel(drawer, true);
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (btn) {
            btn.removeAttribute("aria-disabled");
            btn.textContent = original;
          }
        });
    });

    /* Quantity change / remove inside cart drawer and cart page */
    document.addEventListener("click", function (e) {
      var step = e.target.closest("[data-qty-step]");
      if (step) {
        e.preventDefault();
        var input = step.parentElement.querySelector("input");
        if (!input) return;
        var delta = parseInt(step.getAttribute("data-qty-step"), 10);
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = next;
        changeLine(input.getAttribute("data-line-key"), next);
        return;
      }
      var remove = e.target.closest("[data-line-remove]");
      if (remove) {
        e.preventDefault();
        changeLine(remove.getAttribute("data-line-remove"), 0);
      }
    });

    document.addEventListener("change", function (e) {
      var input = e.target.closest("[data-line-key]");
      if (input && input.tagName === "INPUT") {
        changeLine(input.getAttribute("data-line-key"), Math.max(0, parseInt(input.value, 10) || 0));
      }
    });
  }

  function changeLine(key, quantity) {
    if (!key) return;
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity, sections: "cart-drawer" })
    })
      .then(function (r) { return r.json(); })
      .then(function (body) {
        refreshCartUI(body.sections);
        if (document.body.getAttribute("data-template") === "cart") window.location.reload();
      })
      .catch(function () { window.location.reload(); });
  }

  /* -------------------------------------------------------- Variant picker */

  function initVariants() {
    $$("[data-variant-picker]").forEach(function (root) {
      var dataEl = $("[data-variant-json]", root);
      if (!dataEl) return;
      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }

      function selected() {
        return $$('input[type="radio"]:checked', root).map(function (i) { return i.value; });
      }

      function match(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, idx) { return o === opts[idx]; });
        });
      }

      function apply() {
        var variant = match(selected());
        var idInput = $("[data-variant-id]", root);
        var priceEl = $("[data-variant-price]", root);
        var compareEl = $("[data-variant-compare]", root);
        var btn = $("[data-add-button]", root);
        var quota = $("[data-quota]", root);

        if (!variant) {
          if (btn) {
            btn.disabled = true;
            btn.textContent = "Unavailable";
          }
          return;
        }

        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = money(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = money(variant.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (btn) {
          btn.disabled = !variant.available;
          btn.textContent = variant.available ? btn.getAttribute("data-label-add") : "Sold out — 429";
        }
        if (quota) {
          var threshold = parseInt(quota.getAttribute("data-threshold"), 10) || 12;
          var qty = variant.inventory_quantity;
          var tracked = variant.inventory_management === "shopify";
          if (variant.available && tracked && qty > 0 && qty <= threshold) {
            quota.hidden = false;
            var label = $("[data-quota-label]", quota);
            var fill = $("[data-quota-fill]", quota);
            if (label) label.textContent = qty + " remaining in this size";
            if (fill) fill.style.transform = "scaleX(" + Math.min(1, qty / threshold).toFixed(3) + ")";
          } else {
            quota.hidden = true;
          }
        }

        if (variant.featured_media && variant.featured_media.id) {
          var fig = $('[data-media-id="' + variant.featured_media.id + '"]');
          if (fig && !reduced) fig.scrollIntoView({ behavior: "smooth", block: "center" });
        }

        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", variant.id);
          history.replaceState({}, "", url.toString());
        }
      }

      root.addEventListener("change", function (e) {
        if (e.target.matches('input[type="radio"]')) apply();
      });
      apply();
    });
  }

  /* -------------------------------------------------------------- Search */

  function initSearch() {
    var panel = $(".search-panel");
    if (!panel) return;
    var input = $('input[name="q"]', panel);
    var results = $("[data-search-results]", panel);
    if (!input || !results) return;
    var timer;

    input.addEventListener("input", function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) {
        results.innerHTML = "";
        return;
      }
      timer = setTimeout(function () {
        fetch(
          "/search/suggest?q=" +
            encodeURIComponent(q) +
            "&resources[type]=product&resources[limit]=6&section_id=predictive-search"
        )
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, "text/html");
            var next = parsed.querySelector("[data-search-results-inner]");
            results.innerHTML = next ? next.innerHTML : "";
            initReveal();
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* ---------------------------------------------------------------- Boot */

  function boot() {
    initReveal();
    initQuota();
    initAnnounce();
    initPanels();
    initCart();
    initVariants();
    initSearch();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
